// extracted by mini-css-extract-plugin
export var table = "_uq-0";